import { exhaustiveCheck } from "../../../core/models";

export enum ETransactionType {
  GIVE = "GIVE",
  RECIEVE = "RECIEVE",
  PRODUCT_BUY = "PRODUCT_BUY",
  PRODUCT_SELL = "PRODUCT_SELL",
  // SALARY = "SALARY",
  EXPENSE = "EXPENSE",
}

export interface ITransactionType {
  id: string;
  label: string;
}

export function transactionTypeToString(type: ETransactionType): string {
  switch (type) {
    case ETransactionType.GIVE:
      return "Pul verişi";
    case ETransactionType.RECIEVE:
      return "Pul alışı";
    case ETransactionType.PRODUCT_BUY:
      return "Mal alışı";
    case ETransactionType.PRODUCT_SELL:
      return "Mal satışı";
    // case ETransactionType.SALARY:
    //   return "Maaş";
    case ETransactionType.EXPENSE:
      return "Xərc";
    default:
      exhaustiveCheck(type);
  }

  return "";
}

export const transactionTypeOptions = Object.entries(ETransactionType).map<ITransactionType>((item) => {
  const [key, value] = item;
  return {
    id: key,
    label: transactionTypeToString(value),
  };
});

export const basicTransactionTypeOptions = transactionTypeOptions.filter((item) => {
  const key = item.id;
  return key === ETransactionType.GIVE || key === ETransactionType.RECIEVE; // || key === ETransactionType.SALARY;
});
